import { ErrorFilledSVG, Icon } from "@newsela/angelou";

import useHasFeature from "@/features/useHasFeature";
import {
  TRANSLATION_DEFAULT_LANGUAGE_CODE,
  VIEW_PAGE_LISTEN_TO_TRANSLATION_EXPERIMENT,
} from "@/view/TiptapArticleBody/components/TranslateDrawer/TranslateDrawer.constants";
import {
  ILanguage,
  ITranslationData,
  ITranslationError,
} from "@/view/TiptapArticleBody/components/TranslateDrawer/TranslateDrawer.interface";
import ListenToTranslationButton from "./ListenToTranslationButton";
import {
  bodyStyles,
  errorAIIconStyles,
  translatedTextStyles,
} from "./TranslateDrawerBody.styles";
import TranslateDrawerLoading from "./TranslateDrawerLoading";

interface TranslateDrawerBodyProps {
  language: ILanguage | undefined;
  isError: boolean;
  isLoading: boolean;
  translationData: ITranslationData | undefined;
  translationError: ITranslationError | undefined;
}

const TranslateDrawerBody = ({
  isError = false,
  isLoading = false,
  language,
  translationData,
  translationError,
}: TranslateDrawerBodyProps) => {
  const languageCode = language?.code || TRANSLATION_DEFAULT_LANGUAGE_CODE;

  const { translated_text: translatedText } = translationData || {};

  const { errorMessage } = translationError || {};

  const [hasListenToTranslateFeature] = useHasFeature(
    VIEW_PAGE_LISTEN_TO_TRANSLATION_EXPERIMENT,
  );

  const shouldShowListenButton =
    hasListenToTranslateFeature &&
    translatedText &&
    language?.supports_listening;

  if (isLoading) {
    return <TranslateDrawerLoading />;
  }

  return (
    <div css={bodyStyles}>
      <p dir="auto" lang={languageCode} css={[translatedTextStyles(isError)]}>
        {isError && (
          <Icon
            SvgComponent={ErrorFilledSVG}
            size={Icon.sizes.md}
            __cssFor={{
              root: { ...errorAIIconStyles },
            }}
          />
        )}

        {translatedText || errorMessage}
      </p>
      {shouldShowListenButton && (
        <ListenToTranslationButton
          text={translatedText}
          languageCode={languageCode}
        />
      )}
    </div>
  );
};

export default TranslateDrawerBody;
